<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="
        chk_relation_type_editable('/master/list') ? fromParentBtn : ''
      "
      :btnClass="'btn-primary'"
      :btnToLink="'/circuit/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div
      class="w100"
      v-if="
        typeof circuit_list === 'object' && Object.keys(circuit_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 30%">名称</th>
            <th style="width: 15%">サーキットコード</th>
            <th style="width: 20%">略称</th>
            <th style="width: 20%">表示</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in circuit_list" :key="list.id">
            <td>{{ list.label }}</td>
            <td>{{ list.circuit_cd }}</td>
            <td>{{ list.short_label }}</td>
            <td>{{ list.print_label }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                v-if="chk_relation_type_editable('/master/list')"
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'CategoryListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: 'サーキットマスタ一覧',
      fromParentBtn: 'データ登録',
      circuit_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
  },
  computed: {
    ...mapState({}),
    circuit_list: function () {
      const lists = [...this.circuit_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadCircuitList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = 'サーキットマスタです。'
  },

  methods: {
    async delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.region_obj.find(region => {
          return region.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'circuit' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadCircuitList()
          })
      }
    },
    async loadCircuitList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/circuit/lists', params)
        .then(async response => {
          console.log('loadCircuitList response', response)
          this.circuit_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.circuit_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/circuit/' + target + '/' })
    }
  }
}
</script>
